import type { FieldObject, Patient } from '@pbt/pbt-ui-components'

export function updateSentRemindersPreferences(
  patients: Patient[],
  sendRemindersFields: FieldObject,
) {
  return patients.map((patient) => ({
    ...patient,
    // If the switch is ON (do not share reminders = true), then sendReminders should be false
    // If the switch is OFF (share reminders = false), then sendReminders should be true
    sendReminders: (() => {
      const fieldName = `${patient.id}SendReminders`
      const field = sendRemindersFields[fieldName]
      const preference = field?.value
      return preference
    })(),
  }))
}
